const LONG_TITLE_LENGTH = 28;
export const isLongTitle = (title)=>title.length > LONG_TITLE_LENGTH;

//# sourceMappingURL=helpers.js.map